// UK date formatting — display Europe/London
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const LONDON = "Europe/London";

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = dayjs.utc(iso).tz(LONDON);
  return d.format("DD/MM/YYYY");
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return dayjs.utc(iso).tz(LONDON).format("DD/MM/YYYY HH:mm");
}

export function fmtRelative(iso) {
  if (!iso) return "—";
  const d = dayjs.utc(iso).tz(LONDON);
  const now = dayjs().tz(LONDON);
  const diffDays = d.startOf("day").diff(now.startOf("day"), "day");
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Tomorrow";
  if (diffDays === -1) return "Yesterday";
  if (diffDays > 0) return `In ${diffDays} days`;
  return `${Math.abs(diffDays)} days ago`;
}

export function toInputDate(iso) {
  if (!iso) return "";
  return dayjs.utc(iso).tz(LONDON).format("YYYY-MM-DD");
}

export function fromInputDate(str) {
  // Interpret the picked date as end-of-day London time, store as UTC ISO
  if (!str) return null;
  return dayjs.tz(`${str} 17:00`, LONDON).utc().toISOString();
}

export function statusColor(status) {
  switch (status) {
    case "completed":
    case "done":
    case "sent":
      return "bg-emerald-100 text-emerald-700 border-emerald-200";
    case "in_progress":
    case "approved":
      return "bg-blue-100 text-blue-700 border-blue-200";
    case "on_hold":
    case "paused":
    case "pending_approval":
      return "bg-amber-100 text-amber-800 border-amber-200";
    case "cancelled":
    case "blocked":
    case "failed":
      return "bg-slate-100 text-slate-600 border-slate-200";
    case "overdue":
      return "bg-rose-100 text-rose-700 border-rose-200";
    default:
      return "bg-slate-100 text-slate-700 border-slate-200";
  }
}
